import { WidthWrapper } from 'components'
import { DashboardFolderHeader, DashboardList } from 'modules/dashboard'

import './job-folder-page.styles.scss'

export function JobFolderPage() {
  return (
    <WidthWrapper className="JobFolder-page">
      <DashboardFolderHeader />
      <DashboardList isFolder />
    </WidthWrapper>
  )
}
